module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    staticClass: "legacy-workspace"
  }, [_c('core-drawer', {
    attrs: {
      "drawer": _vm.drawer
    },
    on: {
      "toggleDrawer": _vm.toggleDrawer
    }
  }), _vm._v(" "), _c('core-toolbar', {
    attrs: {
      "drawer": _vm.drawer
    },
    on: {
      "openDrawer": _vm.openDrawer
    }
  }), _vm._v(" "), _c('v-main', [(_vm.containerView) ? _c('div', {
    staticClass: "container-fluid pb-3"
  }, [_c('router-view')], 1) : _c('router-view')], 1), _vm._v(" "), _c('core-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30fe734a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashVuetify.vue
// module id = 2068
// module chunks = 0